import React from 'react';
import { ShieldCheck, AlertTriangle } from 'lucide-react';
import PolicySectionCard from '@/components/policy/PolicySectionCard';
import PageHeader from '@/components/layout/PageHeader';
import PolicyLayout from '@/components/policy/PolicyLayout';
import { motion } from 'framer-motion';

const AcceptableUsePolicy = () => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const item = {
    hidden: { y: 20, opacity: 0 },
    show: { y: 0, opacity: 1 }
  };

  return (
    <PolicyLayout>
      <PageHeader
        title="Acceptable Use Policy"
        description="Last updated: April 11, 2025"
        icon={<ShieldCheck className="w-8 h-8 text-primary" />}
      />

      {/* Cards Grid */}
      <motion.div 
        className="space-y-6"
        variants={container}
        initial="hidden"
        animate="show"
      >
        <motion.div variants={item}>
          <PolicySectionCard
            title="Prohibited Activities"
            icon={AlertTriangle}
            variant="emerald"
          >
            <p className="mb-4">You agree NOT to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Post or share offensive, hateful, or illegal content</li>
              <li>Use automated scripts or bots to access the platform</li>
              <li>Engage in cheating or bypass assessments unfairly</li>
              <li>Upload malicious files or code</li>
              <li>Attempt to disrupt or hack our services</li>
            </ul>
          </PolicySectionCard>
        </motion.div>

        <motion.div variants={item}>
          <PolicySectionCard
            title="Consequences"
            icon={ShieldCheck}
            variant="blue"
          >
            <p>Violation may result in account suspension or termination without refund.</p>
          </PolicySectionCard>
        </motion.div>
      </motion.div>
    </PolicyLayout>
  );
};

export default AcceptableUsePolicy;
